__turbopack_context__.v({
  "cell": "three-d-marquee-module__wqAx-q__cell",
  "column": "three-d-marquee-module__wqAx-q__column",
  "grid": "three-d-marquee-module__wqAx-q__grid",
  "hLine": "three-d-marquee-module__wqAx-q__hLine",
  "image": "three-d-marquee-module__wqAx-q__image",
  "plane": "three-d-marquee-module__wqAx-q__plane",
  "root": "three-d-marquee-module__wqAx-q__root",
  "stage": "three-d-marquee-module__wqAx-q__stage",
  "vLine": "three-d-marquee-module__wqAx-q__vLine",
});
